import React, { useState } from "react";

type RadioButtonProps = {
    id: string;
    name: string;
    label: string;
    checked: boolean;
    onChange: () => void;
};

const RadioButton: React.FC<RadioButtonProps> = ({ id, name, label, checked, onChange }) => {
    return (
        <div className="flex items-center border-[1.5px] border-violet-50 rounded-[12px] p-4 max-[576px]:px-[14px] max-[576px]:py-[12px]">
            <input
                type="radio"
                id={id}
                name={name}
                checked={checked}
                onChange={onChange}
                className="hidden"
            />
            <label
                htmlFor={id}
                className="relative pl-[36px] cursor-pointer text-black font-semibold inline-block w-full max-[576px]:text-[14px] max-[576px]:leading[18px]"
            >
                {label}
                <span className="absolute left-0 top-0 w-[24px] h-[24px] rounded-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="11.5" stroke="#B9BACC" />
                    </svg>
                </span>
                <span className={`absolute left-0 top-0 w-[24px] h-[24px] rounded-full transition-all ${checked ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`} >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="11.5" stroke="#1C225A" />
                        <circle cx="12" cy="12" r="9" fill="#1C225A" />
                    </svg>
                </span>
            </label>
        </div>
    );
};

type RadioGroupProps = {
    name: string;
    options: { id: string; label: string; value: string }[];
    selectedValue: string;
    onChange: (value: string) => void;
    mobileWidth?: string;
};

const RadioGroup: React.FC<RadioGroupProps> = ({ name, options, selectedValue, mobileWidth, onChange }) => {
    return (
        <div className={`grid grid-cols-2 gap-6 max-[576px]:gap-[16px] ${mobileWidth === "1/2" ? "max-[576px]:grid-cols-2" : 'max-[576px]:grid-cols-1'}`}>
            {options.map((option) => (
                <RadioButton
                    key={option.id}
                    id={option.id}
                    name={name}
                    label={option.label}
                    checked={selectedValue === option.value}
                    onChange={() => onChange(option.value)}
                />
            ))}
        </div>
    );
};



export { RadioButton, RadioGroup };
